var map = {
	"./about/about-1.webp": 5009,
	"./about/about-10.webp": 4367,
	"./about/about-11.webp": 2780,
	"./about/about-12.webp": 745,
	"./about/about-13.webp": 1022,
	"./about/about-14.webp": 755,
	"./about/about-2.webp": 9396,
	"./about/about-3.webp": 8759,
	"./about/about-4.webp": 9690,
	"./about/about-5.webp": 7541,
	"./about/about-6.webp": 7707,
	"./about/about-7.webp": 2891,
	"./about/about-8.webp": 1198,
	"./about/about-9.webp": 3945,
	"./about/about-m.webp": 8461,
	"./about/about-r.webp": 7204,
	"./error/error-404.svg": 7511,
	"./error/error.svg": 6416,
	"./favicon/favicon.svg": 4884,
	"./hero/hero-graphics.svg": 4140,
	"./hero/hero-img.png": 7106,
	"./image1.webp": 7012,
	"./image10.webp": 8292,
	"./image11.webp": 151,
	"./image12.webp": 4550,
	"./image14.webp": 88,
	"./image2.webp": 3729,
	"./image3.webp": 3702,
	"./image4.webp": 5547,
	"./image5.webp": 824,
	"./image6.webp": 7349,
	"./image7.webp": 3178,
	"./image8.webp": 6879,
	"./image9.webp": 1996,
	"./img.webp": 6911,
	"./img1.webp": 1086,
	"./img3.webp": 2844,
	"./logo/logo-2.png": 6991,
	"./logo/logo.png": 6062,
	"./path/flutter.png": 9881,
	"./path/path-angular.jpg": 2807,
	"./path/path-bootstrap.jpg": 9159,
	"./path/path-html.jpg": 3142,
	"./path/path-java.jpg": 2577,
	"./path/path-javascript.jpg": 6672,
	"./path/path-nodejs.jpg": 8860,
	"./path/path-php.jpg": 7717,
	"./path/path-python.jpg": 5707,
	"./path/path-react.jpg": 9612,
	"./path/path-sql.jpg": 5973,
	"./path/path-symfony.jpg": 3122,
	"./path/path-wordpress.jpg": 7556,
	"./path/spring.png": 6884,
	"./slide.webp": 6513,
	"./slide1.webp": 9964,
	"./slide2.webp": 633,
	"./slide3.webp": 1534,
	"./slide4.webp": 5075,
	"./slide6.webp": 2141,
	"./tab/tab-1.svg": 4202,
	"./tab/tab-2.svg": 6553,
	"./web1.webp": 8769
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;